import { Expose, Transform } from "class-transformer";
import { PlusAppliesOnEnum, PlusCountingUnitEnum } from "@altertec_gparn/lib";
import { toCents, toMinutes } from "@/utils/numberUtils";

export class CreatePlusDto {
  @Expose()
  name: string;

  @Expose()
  description?: string | null;

  @Expose()
  @Transform(({ value }) => toCents(value))
  defaultUnitPrice: number;

  @Expose()
  countingUnit: PlusCountingUnitEnum;

  @Expose()
  appliesOn?: PlusAppliesOnEnum | null;

  @Expose()
  @Transform(({ value }) => (value === null || value === undefined || value === "" ? null : toMinutes(Number(value))))
  minimumWorkedMinutes?: number | null;

  @Expose()
  isActive: boolean;

  @Expose()
  appliesToCompany?: boolean;

  @Expose()
  operativeUnitId?: string | null;

  @Expose()
  appliesToProjectOperativeUnit?: boolean;

  @Expose()
  taskTypeIds?: string[];

  @Expose()
  payrollConceptKey?: string | null;
}
